<template>
    <div id="container" :style="{ width: '100%', height: '100%', padding: '0px' }">

        <a-layout style="height: 100%;">
            <a-layout-sider style="border-right: 1px solid #eee" width="130" id="knowledgMenu">
                <div style="height: 24px;">
                    <div style="    display: flex;justify-content: flex-end"
                        v-if="showHistory == true && sessionList.length > 0">
                        <a-tooltip placement="right">
                            <template #title>
                                <span>历史记录</span>
                            </template>
                            <a-button class="historyButton" type="text" shape="circle"
                                @click="showHistory = !showHistory">
                                <svg-icon class="svgIcon" name="历史记录" size="25" color="#444444"
                                    style="    margin-right: 0px;"></svg-icon></a-button>

                        </a-tooltip>
                    </div>
                </div>

                <ul style="padding: 10px;    list-style-type: none;">

                    <li v-for="(item, index) in cardList" v-bind:key="index">
                        <div :class="articleAppId == item.id ? 'cardList cardListed' : 'cardList'"
                            @click="toClick(item)">{{
                                item.appName
                            }}</div>
                    </li>
                </ul>
            </a-layout-sider>


            <a-layout-content>
                <div style="display: flex;height: 100%;">
                    <div style="width: 200px;background-color: white;  padding: 0px 4px;"
                        v-if="!showHistory && sessionList.length > 0">
                        <div style="width: 100%;">
                            <div style="display: flex;width: 100%;    align-items: center;
    justify-content: space-between;  ">
                                <div class="historyText">历史记录</div>
                                <a-tooltip placement="right">
                                    <template #title>
                                        <span>收起历史</span>
                                    </template>
                                    <a-button class="historyButton" type="text" shape="circle"
                                        @click="showHistory = !showHistory">
                                        <svg-icon class="svgIcon" name="收起" size="15" color="#444444"
                                            style="    margin-right: 0px;"></svg-icon></a-button>

                                </a-tooltip>
                            </div>
                            <div class="divFlex">
                                <div class="newChatButton" @click="newChat">
                                    新建对话
                                </div>
                            </div>
                            <div :style="sessionStyle">
                                <div v-for="item, index in sessionList" @click="toClickItem(item)" v-bind:key="index"
                                    :class="item.id == active ? 'session session-active' : 'session'">
                                    <div style="    text-overflow: ellipsis;
    overflow: hidden;"><span class="sessionTitle">{{ item.title }}</span></div>
                                    <div style="margin-top: 10px;">
                                        <div
                                            style="display: flex;align-items: center;    justify-content: space-between;">
                                            <span style="font-size: 13px;"> {{ item.updateTime }}</span>
                                            <svg-icon name="垃圾" color="#444444" size="13" style=" margin-right: 0px;"
                                                class="trash" @click="toDelete(item)"></svg-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="gutter-row QP" :style="pageContentStlye">
                        <div class="gutter-box" style="position: relative;padding-bottom:0px;">
                            <div style="text-align: center;" class="QP-Header">
                                <div style="font-size: 32px;
    font-weight: 700;
    letter-spacing: 2px;display: flex
;
    justify-content: center;
    align-items: center;">
                                    <img src="../../assets/ailogo.png"
                                        style="width: 40px;height:40px;margin-right: 10px;">
                                    {{ articleType }}
                                </div>
                            </div>
                            <div v-if="showChat == false" style="    
    width: 100%;
    display: flex;    justify-content: center;margin-top:60px
;">
                                <div style="width: 69%;   
    position: absolute;">
                                    <div class="sub-sub-title-line" style="    font-weight: 600;">
                                        您的问题一定要基于本知识库的内容，超纲题目我回答不了哦

                                    </div>
                                    <div class="sub-sub-title-line" style="    font-weight: 600;">
                                        您的问题越详细，越有利于我为您提供准确答案，您可以试试这样问我：
                                    </div>
                                    <div class=" sub-sub-title-line">
                                        1、某某品牌 某某产品的具体参数是什么?



                                    </div>
                                    <div class=" sub-sub-title-line">2、帮我统计下X月X日-X月X日的某产品价格走势
                                   
                                    </div>
                                    <div class=" sub-sub-title-line">
                                        3、帮我写一篇报告，第一部分是...第二部分是...第三部分是...
                                    </div>
                                </div>

                            </div>

                            <div style="margin-top: 10px;" class="knowledgePage">
                                <ChatPage :pageHeight="pageHeight" :postParams="postParams" 
                                    @toChangeSelectTrue="toChangeSelectTrue" @toChangeSendText="toChangeSendText"
                                    @toChangeSendTextTrue="toChangeSendTextTrue" @toReloadSession="toReloadSession"
                                    :sendText="sendTextText" :active="{ active: active, articleAppId: articleAppId }"
                                    :conversationId="conversationId" :articleAppId="articleAppId" @toShow="toShow" :cardList="cardList">
                                </ChatPage>
                            </div>
                            <div
                                style="padding: 0px 200px 0px 100px;position: absolute;bottom: 10px;    display: flex;width: 100%;justify-content: center;">
                                <div
                                    :class="{ 'sendTextContainer': true}">


                                    <div
                                        :class="{ 'sendTextArea1': true }">
                                        <a-textarea :bordered="false" v-model:value="sendText"
                                             class="knowLedegeTextarea" :autosize="{ minRows: 1, maxRows: 4 }"
                                            placeholder="通过shift+回车换行" allow-clear @pressEnter="handleKeyPress"
                                            @focus="handleFocus" @blur="handleBlur"
                                            
                                            >


                                        </a-textarea>

                                        <div class="sendButton" style="margin-left: 5px;" @click="toSendText"><img
                                                style="width: 50%;" src="../../assets/send.png">
                                        </div>


                                    </div>

                                </div>
                            </div>

                            <div style=" position: absolute;
    bottom: 0px;display: flex;     width: 100%;
    align-items: center;
    justify-content: center;  font-size: 12px;color: #faad14;margin-top: 5px;text-align: center;">
                                AI会犯错，请核查重要信息
                            </div>
                        </div>
                    </div>




                </div>
            </a-layout-content>


        </a-layout>

    </div>
    <a-modal title="删除此对话" v-model:visible="deleteVisible" :confirm-loading="confirmLoading" centered @ok="handleOk">
        <p>是否确定删除此对话？</p>
    </a-modal>
</template>
<script>
export default {
    name: 'KnowledgeDetail'
}
</script>
<script setup>

import router from '@/router';

import { nextTick, onMounted, ref, watch,computed } from 'vue';

import ChatPage from './component/chatPage.vue';
import { message } from 'ant-design-vue';
import { chatPage, deleteChat } from '../knowledgeComponent/qiuuindex.js'
import store from '@/store';
import dayjs from 'dayjs';
import { getApp } from '../homePageComponent/js';

const articleAppId = ref("")
const articleType = ref("")
const selectTrue = ref(false)
const showChat = ref(false)
const active = ref(0)
const cardList = ref([

])
const toShow = () => {
    showChat.value = true
}
const toGetArticleType = () => {
  
    var result = cardList.value.find(item => item.id == router.currentRoute.value.query.knowId)
    articleType.value = result ? result.appName : null
}
  const storeCompany = computed(() => {
      if (store.getters.company)
        return store.getters.company
      else return {}
    })
watch(() => router.currentRoute.value.query, (val, old) => {

    if (val && val.knowId != old.knowId && router.currentRoute.value.path.indexOf('KnowledgeDetail') > -1) {

        articleAppId.value = val.knowId

     

        active.value = router.currentRoute.value.query.knowId

        if (active.value) {
            showChat.value = true
        }
        toGetApp()
        nextTick(()=>{
            reloaddata()
            nextTick(()=>{
                    toGetArticleType()
            })
        
        })

        


    }

})
watch(() => cardList.value, (val, old) => {
    if (val && val.length > 0) {
        toGetArticleType()
    }
})

const sendText = ref('')
const sendTextText = ref({ send: false, sendText: '' })
const pageHeight = ref()
const pageContentStlye = ref()
const conversationId = ref()
const sessionStyle = ref()

const textAreaFocus = ref(false)
onMounted(() => {
    var height = document.getElementById('layoutContent').clientHeight - 142
    sessionStyle.value = { height: height + 'px', 'overflow-y': 'auto' }
    toGetApp()

  

  
  

})
watch(()=>storeCompany.value,(val,old)=>{
    if(val!=old){
        console.log('company changed in KnowledgeDetail.vue',val,old)
        toGetApp()
    }
})
const toGetApp = () => {
    console.log('toGetApp',store.getters.company)
    if(store.getters.company){
         getApp({ companyId: store.getters.company.companyId }).then((res) => {
        cardList.value = res.data
        setTimeout(() => {
        if (router.currentRoute.value.query.knowId) {
        articleAppId.value = router.currentRoute.value.query.knowId
    }
    else articleAppId.value = cardList.value[0].id
        var parentELement = document.querySelector('.QP')

        if (parentELement) {

            var childrenElement = document.querySelector('.QP-Header')

            if (childrenElement) {
                console.log(parentELement.offsetHeight + "" + childrenElement.offsetHeight + "childrenElement.offsetHeight")
                var pageheight = parentELement.offsetHeight - childrenElement.offsetHeight - 40 - 42 - 10
                var pageWidth = document.querySelector('.ant-layout-content')

                pageHeight.value = pageheight
                pageContentStlye.value = { height: '100%', 'flex': 1, 'width': (pageWidth.offsetWidth - 380 - 280) + 'px' }
            }
        }
        reloaddata()
    }, 50)
        store.dispatch('appList', res.data)

    })
    }
   
}
const handleFocus = (e) => {

    textAreaFocus.value = true

}
const handleBlur = () => {
    if (!sendText.value)
        textAreaFocus.value = false

}

const changeSendTextTrue = ref(false)
const toChangeSendTextTrue = (val) => {

    changeSendTextTrue.value = val

}
const toReloadSession = (res) => {

    // router.push({
    //     path: '/KnowledgeDetail',
    //     query: { knowId: router.currentRoute.value.query.knowId, conversationId: res }
    // })
    reloaddata()
    conversationId.value=res
    // active.value='newChat'
    console.log(res,'conversationId')
}
const reloaddata = () => {
   
    changeSendTextTrue.value=false
    //router.currentRoute.value.query.knowId
  
    console.log(cardList.value,'articleAppId.value',articleAppId.value)
    if(cardList.value.length>0){
        chatPage({
        id: Number(articleAppId.value),
        appId: cardList.value.find(item=>item.id==articleAppId.value).appId,
        clientId: store.getters.clientId,
        companyId: store.getters.company.companyId,
        current: 1,
        size: 10000
    }).then((res) => {
        conversationId.value = null
        sessionList.value = res.data.records.length > 0 ? res.data.records.sort((a, b) => b.id - a.id) : res.data.records

        if (sessionList.value.length > 0) {
            var result = router.currentRoute.value.query.conversationId != null ? res.data.records.find(item => item.conversationId == router.currentRoute.value.query.conversationId) : null
            showHistory.value = false
            showChat.value = true
            if (result == null) {

                active.value = sessionList.value[0].id
                conversationId.value = sessionList.value[0].conversationId
                router.push({
                    path: '/KnowledgeDetail',
                    query: { knowId: router.currentRoute.value.query.knowId, conversationId: sessionList.value[0].conversationId,id:sessionList.value[0].id }
                })

            }
            else {
             
                active.value = router.currentRoute.value.query.id

                if (res.data.records.length > 0) {


                    conversationId.value = result.conversationId

                }


            }
        }
        else {
            active.value=0
            showChat.value = false
            
                
                router.push({
                    path: '/KnowledgeDetail',
                    query: { knowId: router.currentRoute.value.query.knowId }
                })
           

        }


    })
    }
   
}
const deleteItem = ref()
const deleteVisible = ref(false)
const confirmLoading = ref(false)
const toDelete = (item) => {
    deleteItem.value = item
    deleteVisible.value = true

}
const handleKeyPress = async(e) => {
    console.log(e)
    e.preventDefault();
    // 检查是否是Shift+Enter组合键  
     const textarea = e.target
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    if (e.shiftKey) {
        // sendText.value = sendText.value + '\n'
         // 1️⃣ 在光标处插入换行
    const text = sendText.value
    sendText.value =
      text.slice(0, start) + '\n' + text.slice(end)

    // 2️⃣ Vue 更新后，恢复光标到换行后
    await nextTick()
    textarea.setSelectionRange(start + 1, start + 1)
    } else {
      
        toSendText()
    }


}
const handleOk = () => {

    if (confirmLoading.value == false) {
        confirmLoading.value = true
        if (deleteItem.value.id == 'newChat') {

            confirmLoading.value = deleteVisible.value = false
            reloaddata()
        }
        else {
            deleteChat({ id: deleteItem.value.id }).then(() => {
                message.success('删除成功！')
                confirmLoading.value = deleteVisible.value = false
                reloaddata()
            })
        }
    }
}

const newChat = () => {
    var result = sessionList.value.find(item => item.id == 'newChat')
    if (result == null) {
        sessionList.value.unshift({
            id: "newChat",
            title: '新对话',
            updateTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
        })
        active.value = "newChat"
        router.push({ path: "/KnowledgeDetail", query: { knowId: articleAppId.value, id:"newChat"} })
        conversationId.value = null
        showChat.value = false
    }
    else {
        message.warning('已经是最新的对话！')
    }

}
const showHistory = ref(false)
const postParams = ref(null)
const toSendParam = (params) => {
    postParams.value = params
    selectTrue.value = true
}
const toSendText = () => {
    console.log(changeSendTextTrue, 'changeSendTextTrue')

    if (sendText.value.trim() == '')
        message.warning('发送内容不能为空！')
    else if (changeSendTextTrue.value == true) {
        message.warning('正在请求中，请等待！')
    }
    else {
        changeSendTextTrue.value = true
        sendTextText.value = { send: true, sendText: sendText.value }
    }
    console.log(sendTextText.value, 'sendTextText.value ')

}
const toChangeSendText = () => {
    sendText.value = ""
    sendTextText.value = { send: false, sendText: '' }

}

const toChangeSelectTrue = (value) => {
    selectTrue.value = value
    console.log(selectTrue.value, 'selectTrue.value')
}

const sessionList = ref([
])
const toClick = (item) => {
    console.log(item,'sessionList')
    if(articleAppId.value!=item.id)
    router.push({ path: "/KnowledgeDetail", query: { knowId: item.id} })


}
const toClickItem = (item) => {
    active.value = item.id
    
    router.push({ path: "/KnowledgeDetail", query: { knowId: articleAppId.value, conversationId: item.conversationId,id:item.id } })


}




</script>
<style lang="less">
.knowLedegeTextarea{
    textarea{
        font-size: 16px;
    }
}
</style>
<style lang="less" scoped>

.example {
    color: black;
    font-size: 18px;
    line-height: 36px;
}

.example.question {
    color: #72777c;

}

#knowledgMenu.ant-layout-sider {
    background: white;
    border-image: linear-gradient(90deg, #725bdf 0%, #80a3d5 70%, #bdceea 100%) 0 1 0 0;
}


.historyButton:hover {
    .svgIcon {
        color: #725bdf !important;
    }

}

.trash:hover {
    color: red !important;
}

.session:hover {
    .sessionTitle {
        color: #725bdf
    }
}

.sendTextContainer {


    /*bottom: 72px;*/
    bottom: 0px;
    width: 100%;
    display: flex;
    /* align-items: center; */
    justify-content: center;
}

.sendTextContainer.areafocus {
    animation: showChat 1s both;

    .sendTextArea1 {
        width: 100% !important;

        .ant-input {
            padding: 4px 11px;
        }

        .ant-input-clear-icon {
            display: block;
        }
    }

    .sendButton {
        height: 30px !important;
        width: 30px !important;

    }
}

@keyframes showChat {
    0% {
        opacity: 0;
        transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
        opacity: 1;
    }
}

.sendTextArea1::after {
    content: '';
    display: block;
    width: 100%;
    height: 0;
    border-bottom: 2px solid;
    /* 设置底部边框 */
    border-image: linear-gradient(90deg, rgba(114, 91, 223, 1) 0%, rgba(128, 163, 213, 1) 70%, rgba(189, 206, 234, 1) 100%) 0 0 1 0;
    position: absolute;
    bottom: 0;
    left: 0;
}

.sendTextArea1 {
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid rgba(5, 5, 5, 0.06);


    /* border-right-width: 1px !important; */
    /* outline: 0; */
    padding: 6px 2px;
    position: relative;
    z-index: 1000;
    bottom: 10px;
    background-color: white;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

}

.sendTextArea1 {
    .ant-input {
        padding: 4px 4px;
    }

    .ant-input-clear-icon {
        display: none;
    }

}
</style>
<style scoped>
.knowledgePage .chatContatiner {
    padding: 20px 200px 20px 100px !important

}

.sendTextContainer {

    /*bottom: 72px;*/
    bottom: 10px;
    width: 100%;
}



.sendButton {
    cursor: pointer;
    background-color: #735fdf;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.divFlex {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.session {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 15px;
    cursor: pointer;
}

.session:hover,
.session-active {
    position: relative;
    box-shadow: 0 0 6px 0 rgba(113, 127, 167, .28);
    background-color: #f8f8f8;
}


.session:hover:before,
.session-active:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 2px;
    background-color: #717dc8;
    top: 0;
    left: 0;

}

.sessionTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.newChatButton {
    margin: 15px 0px;
    cursor: pointer;
    width: 168px;
    height: 40px;
    background: #7283c8;
    border-radius: 8px;
    color: white;
    line-height: 40px;
    text-align: center;
}

.historyButton {
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.cardListed,
.cardList:hover {
    border-radius: 8px;
    background: #f1f2f4;
}


.cardList {
    color: black;
    text-align: center;
    cursor: pointer;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 8px;
    padding: 6px 8px;
}

.gutter-box {
    background: #f6f7fb;

    height: 100%;
}

.no-padding {
    padding-bottom: 0px !important;
}

.QP {
    margin-right: 5px
}

.historyText {
    color: #1a2029;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}
</style>
